/**
 * Created by xuyq on 2022/6/24.
 */
import {settings} from '@/myops/core'

settings.request.sys_prefix = '/cssa/'
settings.isESO = window.globalConfig.TYPE === 'bot' ?  false : process.env.VUE_APP_LOGIN_TYPE  === 'ESO'
settings.request.tokenId = 'auth-token'

settings.themeConfig.app.name = 'Chatbot'
settings.themeConfig.app.logo = require('@/assets/images/svg/logo.svg')
settings.themeConfig.app.contentLayoutNav = 'vertical'
settings.themeConfig.appBar.type = 'fixed'
settings.themeConfig.app.skinVariant = 'bordered'
settings.routeLog = false
settings.themeConfig.menu.isVerticalNavMini = true
// settings.themeConfig.menu.verticalMenuAccordion = true
settings.themeConfig.menu.isMenuHidden = false

